import React from "react";

const Search = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M33.474 30.95l-6.042-6.024a14.075 14.075 0 003.003-8.708 14.218 14.218 0 10-14.217 14.217 14.075 14.075 0 008.708-3.003l6.025 6.042a1.776 1.776 0 002.523 0 1.777 1.777 0 000-2.523zM5.554 16.219a10.663 10.663 0 1121.327 0 10.663 10.663 0 01-21.327 0z"
          fill={fill}
      />
    </svg>
);

export default Search;